import { css } from 'styled-components';
import * as colors from '../../colors';
export const ParagraphTiny = css `
  line-height: 1.4em;
  color: ${colors.BLACK_4};
  font-size: 12px;
`;
export const Paragraph02 = css `
  line-height: 1.6em;
  color: ${colors.BLACK_3};
  font-size: 16px;
`;
export const Paragraph03 = css `
  line-height: 1.5em;
  color: ${colors.BLACK_3};
  font-size: 20px;
`;
export const LineHeightDefaultStyle = css `
  line-height: 1.4em;
`;
